import React from "react";
import Comp from "../components/companies/Comp";
import TopCompanies from "../components/companies/topCompanies/TopCompanies";
import HeaderText from "../../admin/components/headerText/HeaderText";

const Companies: React.FC = () => {
  return (
    <div className="p-4 md:p-6 lg:p-8 xl:p-14">
      <Comp />
      <section className="flex flex-col lg:flex-row justify-between items-center">
        <HeaderText text="top companies" />
      </section>
      <TopCompanies />
    </div>
  );
};

export default Companies;
